import baseApi from "@/api/baseApi";

const api = {
  async getContactpersonCourses() {
    const response = await baseApi({
      method: "get",
      url: `/user/contactperson/courses`,
      data: { hideLoader: true },
    });
    return response.data;
  },
  async addContactpersonCourse(course) {
    const response = await baseApi({
      method: "post",
      url: `/user/contactperson/course`,
      data: course,
    });
    return response.data;
  },
  async addContactPersonCourses(courses) {
    const response = await baseApi({
      method: "post",
      url: `/user/contactperson/courses`,
      data: courses,
    });
    return response.data;
  },
  async deleteContactPersonCourses(id) {
    const response = await baseApi({
      method: "delete",
      url: `/user/contactperson/course/${id}`,
    });
    return response.data;
  },
  async updateContactPersonCourses(course) {
    const response = await baseApi({
      method: "put",
      url: `/user/contactperson/course`,
      data: course,
    });
    return response.data;
  },

  getProfilePhoto(email, date, size) {
    let query = "";
    if (size) {
      query = `?size=${size}`;
    }
    if (date) {
      query = query + (size ? "&&" : "?") + date;
    }
    const baseURL = process.env.VUE_APP_APIURL;
    return baseURL + `/user/${email}/profilephoto` + query;
  },

  async putProfilePhoto(email, img) {
    const response = await baseApi({
      method: "put",
      url: `/user/${email}/profilephoto`,
      data: img,
    });

    return response.data;
  },
  async getUserSetting(key) {
    const response = await baseApi({
      method: "get",
      url: `/user/person/settings/${key}`,
      data: { hideLoader: true },
    });

    return response.data;
  },

  async putUserSetting(key, value, hideLoader = true) {
    const headers = {
      "Content-Type": "text/plain",
    } as any;

    if (hideLoader) {
      headers.hideLoader = "true";
    }

    // value must be string, use JSON.stringify() on JSON objects
    const response = await baseApi({
      method: "put",
      url: `/user/person/settings/${key}`,
      data: value,
      headers: headers,
    });

    return response.data;
  },
};

export default api;
